import {
  useEditorDataset,
  useEditorQueryId,
} from "src/components/page-components/QueryPage/context";
import { useQueryPerformanceState } from "src/hooks/useQueryPerformanceState";

export function useEditorQueryPerformanceState() {
  const queryId = useEditorQueryId();
  const dataset = useEditorDataset();

  return useQueryPerformanceState({
    queryId,
    datasetId: dataset?.id,
  });
}
